/* src/app/components/general/nav-bar/nav-bar.component.scss */
:host-context([dir=rtl]) .container__route:after {
  transform-origin: bottom left;
}
:host-context([dir=rtl]) .container__route:hover:after {
  transform-origin: bottom right;
}
.container {
  display: flex;
  height: 53px;
  background-color: #ffffff;
  box-shadow: 0 4px 8px 2px rgba(69, 81, 138, 0.1);
  align-items: center;
  padding: 0 30px;
}
.container__language-button {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  transition: opacity 0.12s linear;
}
.container__language-button:hover {
  opacity: 0.7;
}
.container__language-button--mobile {
  margin-inline: 10px;
}
.container__mobile-top-bar-icon {
  display: none;
}
.container__routes {
  flex: 1;
  display: flex;
}
.container__route {
  display: inline-block;
  position: relative;
  cursor: pointer;
  margin-inline-end: 50px;
  font-size: 18px;
  font-weight: 600;
  color: #000000;
  -webkit-user-select: none;
  user-select: none;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.15s ease-out;
}
.container__route:after {
  content: "";
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: #000000;
  transform-origin: bottom right;
  transition: transform 0.28s ease-out;
}
.container__route:hover:after {
  transform: scaleX(1);
  transform-origin: bottom left;
}
.container__route--active {
  color: #607bee;
}
.container__route--active:after {
  background-color: #607bee;
}
.container__profile-and-settings-wrapper {
  display: flex;
  color: #45518a;
}
.container__icon {
  margin-inline-start: 30px;
}
.container__icon mat-icon {
  height: 20px;
  width: 20px;
  cursor: pointer;
  transition: opacity 0.12s linear;
}
.container__icon mat-icon:hover,
.container__icon mat-icon.menu-open {
  opacity: 0.7;
}
.container__dropdown-menu .mat-menu-content {
  padding: 0;
}
.container__dropdown-option {
  cursor: pointer;
  height: 48px;
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  transition: background-color 0.12s linear;
}
.container__dropdown-option:hover {
  background-color: #f8f9ff;
}
.container__dropdown-option--hidden {
  display: none;
}
@media screen and (max-width: 768px) {
  .container {
    background-color: #45518a;
    padding: 0 20px;
    justify-content: space-between;
  }
  .container__routes {
    display: none;
  }
  .container__profile-and-settings-wrapper {
    display: none;
  }
  .container__notification-and-language-wrapper {
    display: flex;
    color: #ffffff;
    align-items: center;
  }
  .container__mobile-top-bar-icon {
    display: flex;
  }
  .container__mobile-top-bar-icon--clickable {
    cursor: pointer;
    transition: all 0.12s linear;
  }
  .container__mobile-top-bar-icon--clickable:hover {
    opacity: 0.7;
  }
  .container__mobile-top-bar-icon mat-icon {
    height: 33px;
  }
  .container__mobile-route {
    text-decoration: none;
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .container__mobile-route--active {
    background-color: #e0e6fe;
  }
  .container__mobile-route:visited {
    color: #000000;
  }
  .container__mobile-route-text {
    padding: 0 16px;
    height: fit-content;
  }
  .container__mobile-dropdown-option {
    cursor: pointer;
    height: 48px;
    font-size: 14px;
    display: flex;
    align-items: center;
    transition: background-color 0.12s linear;
  }
  .container__mobile-dropdown-option:hover {
    background-color: #f8f9ff;
  }
  .container__mobile-top-bar-icon {
    display: flex;
    color: #ffffff;
  }
  .container__mobile-top-bar-icon--clickable {
    cursor: pointer;
    transition: all 0.12s linear;
  }
  .container__mobile-top-bar-icon--clickable:hover {
    opacity: 0.7;
  }
  .container__mobile-top-bar-icon mat-icon {
    height: 33px;
  }
}
/*# sourceMappingURL=nav-bar.component.css.map */
